export default __webpack_public_path__ + "static/media/biometric-icon.ff1d4f7f.svg";